import { AuthGuard } from '../shared/services';
import { AssociationsRoutes } from './associations/associations.routes';
import { StudentsForImpactRoutes } from './students-for-impact/students-for-impact.routes';
import { CitizensForImpactRoutes } from './citizens-for-impact/citizens-for-impact.routes';
import { CagnottesRoutes } from './cagnottes/cagnottes.routes';
import { DocumentsRoutes } from './documents/documents.routes';
import { SeekersRoutes } from './seekers/seekers.routes';
import { CategoryAssociationRoutes } from './category-association/category-association.routes';
import { DashboardRoutes } from './dashboard/dashboard.routes';
import { PartenairesRoutes } from './partenaires/partenaires.routes';
import { PrivateComponent } from './private.component';
import { UsersRoutes } from './users/users.routes';
import { Route } from '@angular/router';
import { DonationRoutes } from './donation/donation.routes';
import { SubscriptionsRoutes } from './subscriptions/subscriptions.routes';
import { InvoicesRoutes } from './invoices/invoices.routes';

export const PrivateRoutes: Route[] = [
  {
    path: '',
    component: PrivateComponent,
    canActivate: [AuthGuard],
    children: [
      ...DashboardRoutes,
      ...UsersRoutes,
      ...AssociationsRoutes,
      ...StudentsForImpactRoutes,
      ...CitizensForImpactRoutes,
      ...DonationRoutes,
      ...CagnottesRoutes,
      ...PartenairesRoutes,
      ...CategoryAssociationRoutes,
      ...DocumentsRoutes,
      ...SeekersRoutes,
      ...SubscriptionsRoutes,
      ...InvoicesRoutes
    ]
  }
];
